import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CartIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M9 18a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zM3.383 2a3 3 0 012.89 2.193l.044.178L6.45 5h11.987a3 3 0 012.995 2.824l.005.176a3 3 0 01-.04.488l-.05.24-1 4a3 3 0 01-2.731 2.267l-.179.005H8.594l.214 1H18a1 1 0 01.117 1.993L18 18H8a1 1 0 01-.947-.678l-.03-.112L4.36 4.79a1 1 0 00-.861-.783L3.383 4H2a1 1 0 01-.117-1.993L2 2h1.383zm15.055 5H6.88l1.286 6h9.273a1 1 0 00.937-.649l.034-.108 1-4a1 1 0 00-.854-1.236L18.438 7z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
CartIcon.isCarinaIcon = true;
export default CartIcon;
